export interface DynamicSuccessPopUpProps {
  successData?: any;
  config?: DynamicSuccessConfig;
  deepLink?: string;
  productType?: string;
  priceMode?: number;
  onClose?: () => void;
  onPrimaryAction?: () => void;
  onSecondaryAction?: () => void;
}

export interface DynamicSuccessConfig {
  [sectionKey: string]: SectionConfig;
}

export interface SectionConfig {
  order: number;
  label?: string;
  secondary_label?: string;
  options?: SectionOptions;
  displaySection?: boolean;
  title?: string;
  description?: string;
  description_height?: number;
}

export interface SectionOptions {
  [dataSourceKey: string]: {
    [fieldKey: string]: FieldConfig;
  };
}

export interface FieldConfig {
  key: string;
  label: string;
  order: number;
}

export interface ProcessedSection {
  key: string;
  label?: string;
  secondaryLabel?: string;
  order: number;
  fields: ProcessedField[];
}

export interface ProcessedField {
  key: string;
  label: string;
  value: any;
  order: number;
}
